import { defineRecipe as i } from "@pandacss/dev";
import { inputRecipe as r } from "@huspy/briks-core";
import "../../node_modules/lodash/lodash.mjs";
import { pixify as e } from "../../utils/transform.mjs";
const a = i({
  className: "input",
  base: {
    ...r.base,
    width: "100%",
    _hover: r.hover,
    _focus: r.focus,
    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0
    }
  },
  variants: {
    size: e(r.size),
    isError: { true: r.baseError }
  }
}), p = i({
  className: "input-label",
  base: r.label,
  variants: {
    isError: { true: r.labelError },
    isRequired: { true: {} }
  }
}), u = i({
  className: "input-description",
  base: r.hint,
  variants: {
    isError: { true: r.hintError }
  }
});
export {
  a as input,
  u as inputDescription,
  p as inputLabel
};
